import {
  IBrokerFrontendBootResponseSchema,
  IPartnerFrontendBootResponseSchema,
} from "@/types/frontendBoot.types";
import { apiRequest } from "@repo/api-services/Axios";
import { CACHE_KEYS } from "@repo/api-services/CacheKeys";
import { detectPartner } from "@repo/utilities/partner.utility.ts";
import { useQuery } from "@tanstack/react-query";

function useFrontendBoot() {
  const whichPartner = detectPartner();

  // QUERIES FOR PARTNER AND BROKER
  const partnerFrontendBootService = useQuery({
    queryKey: [...CACHE_KEYS.PARTNER_FRONTEND_BOOT, whichPartner],
    queryFn: () => {
      return apiRequest
        .get(`/partner/${whichPartner}/frontend-boot`)
        .then((response) => {
          if (response.data.name === "AxiosError") {
            return {};
          } else {
            return response.data;
          }
        });
    },
    enabled: !!whichPartner,
  });

  const frontendBootService = useQuery({
    queryKey: [...CACHE_KEYS.FRONTEND_BOOT],
    queryFn: () => {
      return apiRequest.get("/frontend-boot").then((res) => {
        if (res.data.name === "AxiosError") {
          return {};
        } else {
          return res.data;
        }
      });
    },
    enabled: import.meta.env.VITE_USER === "broker",
  });

  const partnerFrontendBoot: IPartnerFrontendBootResponseSchema =
    partnerFrontendBootService?.data?.data;
  const brokerFrontendBoot: IBrokerFrontendBootResponseSchema =
    frontendBootService?.data?.data;

  const logo =
    import.meta.env.VITE_USER === "broker"
      ? brokerFrontendBoot?.settings?.general?.logo?.original_url
      : partnerFrontendBoot?.logo?.original_url;

  return {
    logo,
    partnerFrontendBoot,
    brokerFrontendBoot,
    frontendBootService,
    partnerFrontendBootService,
  };
}

export default useFrontendBoot;
